import React from "react"

import {
    Avatar,
    Button,
    Typography,
    Switch,
} from "@mui/material"

import {
    t,
    Trans,
} from "@lingui/macro"
import { Link } from "react-router-dom"
import {Users} from "../../../models";


const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getUserTableColumns = (onToggleSuperAdmin?: (accountId: string, isSuperAdmin: boolean) => void): any => {
    return [
        {
            ...defaultColumnDefinition,
            field: "user",
            headerName: t({
                id: "utc-user",
                message: "Utente"
            }),
            flex: 4,
            sortable: false,
            valueGetter: (params: { row: Users }) => {
                if(params.row.accountDetails !== null){
                    return params.row.accountDetails.firstName + " " + params.row.accountDetails.lastName
                }
            },
        },
        {
            ...defaultColumnDefinition,
            field: "email",
            headerName: t({
                id: "utc-email",
                message: "E-mail"
            }),
            flex: 4,
            sortable: false,
            valueGetter: (params: { row: Users }) => {
                return params.row.username
            },
        },
        {
            ...defaultColumnDefinition,
            field: "account",
            headerName: t({
                id: "utc-account",
                message: "Account"
            }),
            flex: 2,
            sortable: false,
            renderCell: (params: { row: Users }) => {
                return <Trans id={`enums.account-type.${params.row.accountType}`}>
                    {params.row.accountType}
                </Trans>
            },
        },
        {
            ...defaultColumnDefinition,
            field: "location",
            headerName: t({
                id: "utc-location",
                message: "Località"
            }),
            flex: 3,
            sortable: false,
            valueGetter: (params: { row: Users }) => {
                if(params.row.accountDetails !== null){
                    return (params.row.accountDetails.address??"") +
                    (params.row.accountDetails.address?", ":"") +
                    (params.row.accountDetails.city??"") +
                    (params.row.accountDetails.city?", ":"") +
                    (params.row.accountDetails.province??"") +
                    (params.row.accountDetails.province?", ":"")+
                    (params.row.accountDetails.country??"")
                }
            },
        },
        {
            ...defaultColumnDefinition,
            field: "superAdmin",
            headerName: t({
                id: "utc-super-admin",
                message: "Super Admin"
            }),
            flex: 1,
            sortable: false,
            renderCell: (params: { row: Users }) => {
                if (params.row.accountType !== 'ADMIN') {
                    return null;
                }
                return (
                    <Switch
                        checked={params.row.isSuperAdmin || false}
                        onChange={(event) => {
                            if (onToggleSuperAdmin) {
                                onToggleSuperAdmin(params.row.id, event.target.checked);
                            }
                        }}
                        size="small"
                    />
                );
            },
        },
        {
            ...defaultColumnDefinition,
            field: "actions",
            headerName: t({
                id: "utc-actions",
                message: "Azioni"
            }),
            flex: 2,
            sortable: false,
            renderCell: (params: { row: Users }) => (
                <Button
                    variant="outlined"
                    size="small"
                    sx={{
                        textTransform: 'none',
                    }}
                    onClick={() => {
                        // Questo sarà gestito dal componente padre
                        if ((window as any).openGeographicPermissions) {
                            (window as any).openGeographicPermissions(params.row.id)
                        }
                    }}
                >
                    <Typography>
                        <Trans id="user-table.manage-permissions">
                            Gestisci Permessi
                        </Trans>
                    </Typography>
                </Button>
            ),
        },
    ]
}

export default getUserTableColumns
